import { imageFile } from 'common/helpers/miscHelper';

const ExperienceImage = (props) => {
  const { experience, size = 'large', width } = props;

  if (!experience.image) {
    return null;
  }

  const image = imageFile(experience.image, size);

  return <img src={image} alt={experience.title} width={width} />;
};

export default ExperienceImage;
